import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/admin/media")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard/admin/content", search: { tab: "media" } });
  },
});
